import {
  IMPORT_SITES_IN_PROGRESS,
  IMPORT_SITES_SUCCESS,
  IMPORT_SITES_FAIL,
} from "../constants";

const initialState = {
  error: undefined,
  success: null,
  tsvReport: null,
};

/**
 * Import sites reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function importSites(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case IMPORT_SITES_IN_PROGRESS:
      return {
        ...initialState,
      };

    case IMPORT_SITES_SUCCESS:
      return {
        ...state,
        success: true,
        error: null,
        tsvReport: payload.tsvReport,
      };

    case IMPORT_SITES_FAIL:
      return {
        ...state,
        success: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
